import { create } from 'zustand';
import toast from 'react-hot-toast';
import axiosInstance from '@/apis/axiosInstance';
import { isFromApp } from '@/biz/tool';

/** GET /influencer/info 接口返回的 data 结构 */
export interface InfluencerInfoApiResponse {
  code: number;
  message?: string;
  data?: {
    influencers?: any[];
    user?: any;
  };
}

/** 业务层直接使用的达人信息（接口 data.data） */

type InfluencerInfoStore = {
  /** 达人信息 payload，可直接解构 { influencers, user }，成功请求且 code===0 时才有值 */
  influencerInfo: any;
  loading: boolean;
  error: Error | null;
  /** 请求 /influencer/info：code!==0 在 store 内 toast 并返回 null，成功返回 payload */
  fetchInfluencerInfo: () => Promise<any>;
  clearInfluencerInfo: () => void;
};

export const useInfluencerInfoStore = create<InfluencerInfoStore>((set) => ({
  influencerInfo: null,
  loading: false,
  error: null,

  fetchInfluencerInfo: async () => {
    set({ loading: true, error: null });
    try {
      const { data: res } = await axiosInstance.get<InfluencerInfoApiResponse>(
        `/influencer/info?from=${isFromApp() ? 'app' : 'web'}`
      );
      if (res.code !== 0) {
        toast.error(res.message ?? '');
        set({ influencerInfo: null });
        return null;
      }
      // 与原先 data?.data || {} 一致：code===0 时始终给对象，避免成功时误走「无 payload」分支
      const payload: any = res?.data ?? {};
      set({ influencerInfo: payload, error: null });
      return payload;
    } catch (err) {
      const error = err instanceof Error ? err : new Error(String(err));
      set({ error, influencerInfo: null });
      throw err;
    } finally {
      set({ loading: false });
    }
  },

  clearInfluencerInfo: () => set({ influencerInfo: null, error: null })
}));
